import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import { getlang, setlang } from 'src/helper/getlang'
import langM from './lang'
import LoadingComp from '../../../component/LoadingComp'
import { history } from 'src/core/router'
import localstorage from 'src/helper/localstorage'
@inject('store')
@observer
export default class extends React.Component {
  state = {
    lang: {},
    language:'en',
    userName: '',
    password: '',
    showLoding: true,
    uid: '',
  }

  async componentWillMount() {
    //设置语言 start
    let { language } = this.props.location.query
    language =await getlang(language)
    this.setState({
      lang: setlang(language, langM),
      language: language,
    })
    // end
  }
  //qu支付
   componentDidMount(){
    let a = localstorage.get('whatRecharge')
    if (a && a==1) {
      history.replace(`/app/ruby-agent`)
    }else if (a && a==2) {
      history.replace(`/app/recharge`)
      localstorage.set('appReaStatus',401) //充值失败
    }
    
   }

  render() {
    let { lang, showLoding } = this.state
    return <div className="newpaypal" id='newpaypal'>
      <LoadingComp show={showLoding}></LoadingComp>
    </div>
  }
}



// WEBPACK FOOTER //
// src/pages/app/nopaypal/index.js